import type { CSSProperties } from 'react';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';
import { TextInput } from './Text';
import { TextAreaInput } from './TextArea';

export interface INullableTextInputProps {
    autoFocus?: boolean;
    automation?: string;
    className?: string;
    descriptionText?: string;
    descriptionTextClassName?: string;
    disableClickPropagation?: boolean;
    disabled?: boolean;
    error?: string;
    expandableTextArea?: boolean;
    id?: string;
    inputStyle?: CSSProperties;
    name?: string;
    onChange: (value: string | null) => void;
    onDoValidate?: (value?: string | null) => void;
    onEnter?: () => void;
    placeholder?: string;
    tabIndex?: number;
    trimValue?: boolean;
    value: string | null;
}

export function NullableTextInput(props: FormContextProps<INullableTextInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                const nonNullableProps = {
                    ...properties,
                    value: properties.value === null ? '' : properties.value,
                    onChange: (value: string | null) => properties.onChange(value === '' ? null : value),
                };

                if (properties.expandableTextArea) {
                    return (
                        <TextAreaInput
                            {...nonNullableProps}
                            style={properties.inputStyle}
                        />
                    );
                }

                return (
                    <TextInput
                        {...nonNullableProps}
                        style={properties.inputStyle}
                    />
                );
            }}
        </FormContextConsumer>
    );
}

export function NullableTextField(props: FormContextProps<INullableTextInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <NullableTextInput {...props} />
        </Field>
    );
}
